import type { Location, ShopifyPickupOptions } from "../../api/types";
import { closurePill, openPill, pinPill, shopifyPill, shortAddress, type ShopPill } from "./shopLabels";

function Pill({ pill }: { pill: ShopPill }) {
  return <span className={`shop-pill is-${pill.tone}`}>{pill.label}</span>;
}

/**
 * G-203 redesign — one shop as the owner thinks of it: the name, where it is,
 * and what it is doing now. The pills are the page's only status language;
 * "Active" on every row was replaced by dimming the inactive ones.
 */
export function ShopTile({
  location,
  pickup,
  now,
  today,
  selected,
  onOpen,
}: {
  location: Location;
  pickup: ShopifyPickupOptions | null;
  now: Date;
  today: string;
  selected: boolean;
  onOpen: (loc: Location) => void;
}) {
  const closure = closurePill(location, today);
  const shopify = shopifyPill(location, pickup);
  return (
    <button
      type="button"
      className={`shop-tile${location.isActive ? "" : " is-inactive"}${selected ? " is-selected" : ""}`}
      aria-pressed={selected}
      onClick={() => onOpen(location)}
    >
      <div className="shop-tile-who">
        <div className="shop-tile-name">
          {location.name}
          {!location.isActive ? <span className="shop-pill is-muted">Inactive</span> : null}
        </div>
        <div className="shop-tile-address">{shortAddress(location.address)}</div>
      </div>
      {location.isActive ? (
        <div className="shop-tile-pills">
          <Pill pill={openPill(location, now)} />
          {closure ? <Pill pill={closure} /> : null}
          <Pill pill={pinPill(location)} />
          {shopify ? <Pill pill={shopify} /> : null}
        </div>
      ) : null}
    </button>
  );
}
